import now from 'lodash/now';
import { DefaultDatasetUnit } from 'src/redux/helpers';
import {
  SolutionType,
  SolutionDevices,
  SolutionDeviceConfigItem,
  SolutionDeviceConfigModelType,
  SolutionDeviceBulkDeploymentData,
  SolutionDeviceReleaseItem,
  SolutionDeviceItem,
  SolutionDeviceCertDetailsItem,
  SolutionDeviceCertAuditLogsItem,
  CertRequestType,
  CertificateType,
  SolutionDeviceGroups,
  SolutionDeviceGroupPropertyItem,
  SolutionDigitalTwinModel,
  SolutionUserItem,
  SolutionItem,
  SolutionFilesWhitelistItem,
  SolutionSignatureWhitelistItem,
  SolutionJobs,
  SolutionSubscriptionItem,
  SolutionJobStatus,
  SolutionDeviceObservPropsItem,
  SolutionDetailsItem,
  SolutionNamespaceRscLimitData,
  SolutionAdxTablesItem,
  SolutionDevicesModulesList,
  SolutionConsumerFeatures,
  SolutionIndustrialFeatures,
  SubscriptionType,
  SolutionDevicesComponetsList,
  SolutionDevicesRulesManagementList,
  SolutionDevicesSpecificRulesManagementList,
  SolutionNamespaceRscQuotasDetailItem,
  SolutionAlertRuleItem,
} from '../types';
import {
  DashboardSummaryList,
  DashboardsDeviceGroupList,
} from '../types/solutionDashboard';
import {
  SolutionAssetBulkDigitalTwinsItem,
  SolutionAssetBulkDigitalTwinsRootItem,
  SolutionAssetConfig,
  SolutionMappingConfigItem,
  assetDashboardSummaryList,
} from '../types/solutionAssetHierarchy';
import { SolutionRuleConfigurationItem } from '../types/solutionRulesConfiguration';

const getFilteredSoltuions = (data, type) => {
  const item = data.map((ele) => ({
    ...ele,
    kibanaSpaceUrl: ele?.kibanaSpace?.url,
    kibanaSpaceType: ele?.kibanaSpace?.type,
  }));
  switch (type.toUpperCase()) {
    case SolutionType.Consumer.toUpperCase():
      data = item.filter(
        (solution) =>
          solution.solutionType === SolutionType.Consumer ||
          solution.solutionType === null
      );
      break;
    case SolutionType.ioTH.toUpperCase():
      data = item.filter(
        (solution) => solution.solutionType === SolutionType.ioTH
      );
      break;
    default:
      data = item.filter(
        (solution) => solution.solutionType === SolutionType.Industrial
      );
      break;
  }
  return data;
};

export const mapSolutionsListData = (
  items,
  switchValue
): DefaultDatasetUnit<SolutionItem[]> => ({
  data: getFilteredSoltuions(items.items, switchValue),
});

export const mapSolutionDetailsData = (
  response
): DefaultDatasetUnit<SolutionDetailsItem> => {
  const {
    industrialWorkloadInformation,
    industrialWorkloads,
    notificationPreference,
    projects,
    unlimitedCache,
    unlimitedRetention,
    UnlimitedCacheArr,
    UnlimitedRetentionArr,
    cachePeriod,
    retentionPeriod,
    releasePrefix,
    kibanaSpace,
    features,
    isSmsAccountCreation,
    isWeakAuthenticationEnabled,
    assetHierarchyInformation,
    ...rest
  } = response || {};
  let notificationPreferUpdate: number[] = [1, 2, 3];
  if (notificationPreference) {
    notificationPreferUpdate = notificationPreference?.map(
      (notificationPrefer) => {
        if (notificationPrefer === 'email') {
          return 1;
        }
        if (notificationPrefer === 'sms') {
          return 2;
        }
        return 3;
      }
    );
  }
  const consumerFeatures: string[] = [];
  if (features) {
    if (features?.menderSetup?.menderEnabled === true) {
      consumerFeatures.push(SolutionConsumerFeatures.IsMenderEnabled);
    }
    if (features?.dataIngestion === true) {
      consumerFeatures.push(SolutionConsumerFeatures.IsDataIngested);
    }
    if (
      features?.fileSubscriptionServiceSetup?.fileSubscriptionService === true
    ) {
      consumerFeatures.push(SolutionConsumerFeatures.IsFileSubscriptionService);
    }
    if (isSmsAccountCreation === true) {
      consumerFeatures.push(SolutionConsumerFeatures.IsSmsAccountCreation);
    }
    if (isWeakAuthenticationEnabled === true) {
      consumerFeatures.push(SolutionConsumerFeatures.IsWeakAuthentication);
    }
  }

  const industrialFeatures: string[] = [];
  const subscriptionFeatureType: string[] = [];
  if (features) {
    if (features?.dataIngestion === true) {
      industrialFeatures.push(SolutionIndustrialFeatures.IsDataIngested);
    }
    if (features?.isAlarmEventsStreamProcessing === true) {
      industrialFeatures.push(
        SolutionIndustrialFeatures.IsAlarmEventProcessing
      );
    }
    if (
      features?.telemetryStreamProcessingSetup?.isTelemetryStreamProcessing ===
      true
    ) {
      industrialFeatures.push(
        SolutionIndustrialFeatures.IsTelemetryStreamProcessing
      );
    }
    if (
      features?.fileSubscriptionServiceSetup?.fileSubscriptionService ===
        true ||
      features?.isMessageSubscriptionService === true
    ) {
      industrialFeatures.push(SolutionIndustrialFeatures.IsSubscriptionService);
    }
    if (isSmsAccountCreation === true) {
      industrialFeatures.push(SolutionIndustrialFeatures.IsSmsAccountCreation);
    }
    if (
      features?.fileSubscriptionServiceSetup?.fileSubscriptionService === true
    ) {
      subscriptionFeatureType.push(SubscriptionType.Files);
    }
    if (features?.isMessageSubscriptionService === true) {
      subscriptionFeatureType.push(SubscriptionType.Messages);
    }
  }

  return {
    notificationPreference: notificationPreferUpdate,
    industrialWorkloadInformation,
    industrialWorkloads,
    kibanaSpaceUrl: kibanaSpace?.url,
    kibanaSpaceType: kibanaSpace?.type,
    project: projects ? projects[0]?.name : null,
    namespace: projects ? projects[0]?.namespaces[0]?.name : null,
    CachePeriod: cachePeriod,
    RetentionPeriod: retentionPeriod,
    releasePrefix: features?.menderSetup?.releasePrefix
      ? features?.menderSetup?.releasePrefix
      : releasePrefix,
    UnlimitedCache: unlimitedCache,
    UnlimitedRetention: unlimitedRetention,
    UnlimitedCacheArr: unlimitedCache ? ['UnlimitedCache'] : [],
    UnlimitedRetentionArr: unlimitedRetention ? ['UnlimitedRetention'] : [],
    solutionConsumerFeatures: consumerFeatures,
    solutionIndustrialFeatures: industrialFeatures,
    subscriptionType: subscriptionFeatureType,
    telemetryStreamProcessing:
      features?.telemetryStreamProcessingSetup?.streamProcessingType,
    fileSubscription: features?.fileSubscriptionServiceSetup?.subscriptionType,
    isIsa95Standard: assetHierarchyInformation?.isIsa95Standard ?? false,
    features,
    ...rest,
  };
};

export const mapSolutionAlertSubscription = (response) => ({
  data: response.map(({ id, name }) => ({
    value: id,
    label: name,
  })),
});

export const mapSolutionAdlsSubscription = (response): any => ({
  data: response[0],
});

const getAlertRuleSeverity = (severity) => {
  if (severity) {
    if (severity === '1') {
      return 'Critical';
    }
    return 'Minor';
  }
  return '';
};

const getAlertRuleInterval = (schedule) => {
  const interval = schedule?.interval ?? '';
  if (interval) {
    // 15s, 15m, 15h, 15d values available
    if (interval.includes('d')) {
      return interval.replace('d', 'days');
    }
    if (interval.includes('h')) {
      return interval.replace('h', 'hours');
    }
    if (interval.includes('m')) {
      return interval.replace('m', 'mins');
    }
    return interval.replace('s', 'sec');
  }
  return '';
};

const getSubscriptionId = (value) => {
  if (value === '00000000-0000-0000-0000-000000000000') {
    return '';
  }
  return value;
};

export const mapSolutionAlertRules = (
  response
): DefaultDatasetUnit<SolutionAlertRuleItem[]> => ({
  data: response.map((item) => ({
    id: item?.id,
    severity:
      getAlertRuleSeverity(
        item?.actions?.[0]?.params?.subActionParams?.severity
      ) ?? '',
    interval: getAlertRuleInterval(item?.schedule),
    alertType: item?.actions?.[0]?.params?.subActionParams?.type ?? '',
    aggType: item?.params?.criteria?.[0]?.aggType ?? '',
    comparator: item?.params?.criteria?.[0]?.comparator ?? '',
    scheduleInterval: item?.schedule?.interval?.replace(/\D/g, '') ?? '',
    everyTimeUnits: item?.schedule?.interval?.replace(/[0-9]/g, '') ?? '',
    threshold: item?.params?.criteria?.[0]?.threshold?.[0] ?? '',
    timeSize: item?.params?.criteria?.[0]?.timeSize ?? '',
    timeUnit: item?.params?.criteria?.[0]?.timeUnit ?? '',
    metric: item?.params?.criteria?.[0]?.metric ?? '',
    equation: item?.params?.criteria?.[0]?.equation ?? '',
    aggregationValue:
      item?.params?.criteria?.[0]?.customMetrics?.[0]?.aggType ?? '',
    fieldValue: item?.params?.criteria?.[0]?.customMetrics?.[0]?.field ?? '',
    aggregationName:
      item?.params?.criteria?.[0]?.customMetrics?.[0]?.name ?? '',
    customMetrics: item?.params?.criteria?.[0]?.customMetrics?.slice(1) ?? [],
    ruleType: item?.params?.ruleType,
    ...item,
  })),
});

export const mapSolutionRuleConfiguration = (
  response
): DefaultDatasetUnit<SolutionRuleConfigurationItem[]> => ({
  data: response.map((item) => ({
    id: item?.id,
    ...item,
  })),
});

const getListItemId = (field, index) => index + field + now();

export const mapSolutionFilesWhitelistData = (
  items
): DefaultDatasetUnit<SolutionFilesWhitelistItem[]> => ({
  data: items.map((item, index) => ({
    id: getListItemId(item.extension, index),
    ...item,
  })),
});

export const mapSolutionSignatureWhitelistData = (
  items
): DefaultDatasetUnit<SolutionSignatureWhitelistItem[]> => ({
  data: items.map((item, index) => ({
    id: getListItemId(item.signature, index),
    ...item,
  })),
});

export const mapDeviceModelsToConfigList = (
  items: SolutionDigitalTwinModel[] = [],
  contextDigitalTwinsModels: SolutionDigitalTwinModel[] = []
): SolutionDeviceConfigItem[] => {
  const digitalTwinModels = items.map(
    ({ modelDefinitionInfo, ioTCentralTemplateInfo, isEdgeDevice }) => {
      let modelType = SolutionDeviceConfigModelType.ContextModel;
      if (ioTCentralTemplateInfo || modelDefinitionInfo) {
        modelType = SolutionDeviceConfigModelType.DeviceTemplate;
      }
      if (isEdgeDevice) {
        modelType = SolutionDeviceConfigModelType.EdgeDeviceTemplate;
      }

      return {
        id: modelDefinitionInfo.modelId,
        modelType,
        ...modelDefinitionInfo,
      };
    }
  );

  const contextTwinsModels = contextDigitalTwinsModels.map(
    ({ modelDefinitionInfo }) => {
      const modelType = SolutionDeviceConfigModelType.ContextModel;

      return {
        id: modelDefinitionInfo.modelId,
        modelType,
        ...modelDefinitionInfo,
      };
    }
  );

  return [...digitalTwinModels, ...contextTwinsModels];
};

export const mapSolutionDeviceItem = (device): SolutionDeviceItem => {
  const { company, model, ...rest } = device || {};
  return {
    companyId: company?.id,
    companyName: company?.name,
    modelId: model?.modelId,
    modelDisplayName: model?.displayName,
    ...rest,
  };
};

export const mapSolutionDeviceObservProperties = (
  allProperties
): SolutionDeviceObservPropsItem => {
  const { $metadata: data, ...rest } = allProperties || {};
  return {
    MBFILEPATH: data?.MBFILEPATH?.desiredValue,
    MBFILENAME: data?.MBFILENAME?.desiredValue,
    MBROTATEFILE: data?.MBROTATEFILE?.desiredValue,
    MBNUMOFFILE: data?.MBNUMOFFILE?.desiredValue,
    MBPERIOD: data?.MBPERIOD?.desiredValue,
    MBENABLED: data?.MBENABLED?.desiredValue,
    ...rest,
  };
};

export const mapSolutionDevicesData = ({
  devices,
  ...rest
}): SolutionDevices => ({
  data: devices?.map(mapSolutionDeviceItem),
  ...rest,
});

export const mapSolutionDevicesComponentsData = (
  response
): SolutionDevicesComponetsList => {
  let retData = response.map((element) => ({
    requestSchemaType: !element.requestSchema ? '-' : element.requestSchema,
    ...element,
  }));
  retData = retData.filter((comp) => comp.component !== '');
  return { data: retData };
};

export const mapSolutionDevicesModulesData = (
  response
): SolutionDevicesModulesList => {
  const retData = response.map((element) => ({
    moduleType: element.moduleId.includes('$') ? 'system' : 'custom',
    ...element,
  }));
  return { data: retData };
};

export const mapSolutionDashboardsData = (response): DashboardSummaryList => {
  const retData = response.dashboardSummary;
  return { data: retData };
};

export const mapSolutionAssetDashboardsData = (
  response
): assetDashboardSummaryList => {
  const retData = response.dashboardSummary;
  return { data: retData };
};

export const mapSolutionDashboardDeviceGroupData = (
  response
): DashboardsDeviceGroupList => {
  const retData = response;
  return { data: retData };
};

export const mapSolutionRulesManagementData = (
  response
): SolutionDevicesRulesManagementList => {
  const retData = response.map((element) => ({
    ...element,
  }));
  return { data: retData };
};

export const mapSolutionSpecificRulesManagementData = (
  response: any[]
): SolutionDevicesSpecificRulesManagementList => {
  const retData = response.map((element: any) => ({
    ...element,
  }));
  return { data: retData };
};

export const mapSolutionsAssetConfigListData = ({
  items,
  totalCount,
}): SolutionAssetConfig => ({
  data: items,
  totalItems: totalCount,
});

export const mapSolutionDevicesPersistData = (
  response,
  currDevices
): SolutionDevices =>
  mapSolutionDevicesData({
    devices: currDevices?.map((item) => ({
      ...item,
      ...response
        .map(({ devices }) => mapSolutionDeviceItem(devices[0]))
        .find((device) => item.id === device?.id),
    })),
  });

export const mapSolutionDeviceGroups = ({
  deviceGroups,
  ...rest
}): SolutionDeviceGroups => ({
  data: deviceGroups,
  ...rest,
});

export const mapSolutionJobsData = ({ items, totalCount }): SolutionJobs => ({
  data: items.map(({ organizations, ...rest }) => ({
    runLater: rest?.status === SolutionJobStatus.Scheduled,
    organization: organizations[0],
    ...rest,
  })),
  totalItems: totalCount,
});

const getFilteredData = (data, type) => {
  if (type === CertificateType.Mender) {
    data = data.filter(
      (cert) =>
        cert.requestType === CertRequestType.Mender ||
        cert.commonName.includes(CertificateType.Mender)
    );
  } else {
    data = data.filter(
      (cert) =>
        cert.requestType === CertRequestType.IOTC ||
        !cert.commonName.includes(CertificateType.Mender)
    );
  }
  return data;
};

export const mapSolutionDeviceCertDetails = (
  response,
  type
): SolutionDeviceCertDetailsItem[] => {
  const data = response.map((cert) => cert);
  return getFilteredData(data, type);
};

export const mapSolutionDeviceCertAuditLogs = (
  response,
  type
): SolutionDeviceCertAuditLogsItem[] => {
  const data = response.map((cert) => cert);
  return getFilteredData(data, type);
};

export const mapSolutionUsersData = ({
  solutionOwners,
  solutionUsers,
}): DefaultDatasetUnit<SolutionUserItem[]> => {
  const mapUsers = (users: SolutionUserItem[]): SolutionUserItem[] =>
    users.map((x) => x);

  const items = [...mapUsers(solutionOwners), ...mapUsers(solutionUsers)];

  return {
    data: items.map((item) => {
      if (item?.phoneNumber) {
        const countryCodeLength = item.phoneNumber.length - 10;
        const countryCode = item.phoneNumber.substring(0, countryCodeLength);
        const mobileNumber = item.phoneNumber.substring(
          countryCodeLength,
          item.phoneNumber.length
        );
        const groupIds = item?.groupIds || [];
        const siteIds = item?.siteIds || [];

        return { ...item, countryCode, mobileNumber, groupIds, siteIds };
      }
      return item;
    }),
  };
};

export const mapSolutionDeviceGroupDetails = ({ filters, ...data }) => ({
  data: {
    filters: filters.map(({ property, ...rest }) => ({
      property: property.id,
      propertyName: property.displayName,
      ...rest,
    })),
    ...data,
  },
});

export const mapSolutionDeviceGroupProperties = (
  properties: SolutionDeviceGroupPropertyItem[]
) => {
  const mapToOption = ({ description, value, displayName }) => ({
    label: description || displayName,
    value,
  });
  const mapToOptions = (values) => (values ? values.map(mapToOption) : null);

  return {
    data: [
      ...properties.map(
        ({ aggregationFunctions, operators, enums, ...property }) => ({
          ...property,
          operators: mapToOptions(operators),
          aggregationFunctions: mapToOptions(aggregationFunctions),
          enums: mapToOptions(enums),
        })
      ),
    ],
  };
};

export const mapDeviceDepReleasesData = (
  releases
): DefaultDatasetUnit<SolutionDeviceReleaseItem[]> => ({
  data: releases?.map(({ Artifacts }) => Artifacts[0]),
});

export const mapDeviceBulkDeploymentData = ([
  { deploymentDetails, deploymentStatistics },
  logs,
]): SolutionDeviceBulkDeploymentData => {
  const {
    aborted,
    noArtifact,
    pause_before_installing,
    pause_before_rebooting,
    pause_before_committing,
    downloading,
    installing,
    rebooting,
    ...rest
  } = deploymentStatistics || {};
  return {
    details: deploymentDetails,
    statistics: {
      ...rest,
      pause:
        pause_before_installing +
        pause_before_rebooting +
        pause_before_committing,
      skipped: aborted + noArtifact + rest['already-installed'],
      installing: downloading + installing + rebooting,
    },
    logs,
  };
};

function mergeObjects(data) {
  if (!data || data.length === 0) return data;

  const root = data[0]?.root;
  if (!root) throw new Error('No root object found in the input data.');

  const mergedResult: SolutionAssetBulkDigitalTwinsItem = {
    id: root.id,
    relationshipName: root.relationshipName,
    level: root.level,
    properties: root.properties || {},
    children: [],
  };

  const mergeChildren = (children, newChildren) => {
    newChildren.forEach((newChild) => {
      const existingChild = children.find((child) => child.id === newChild.id);

      if (existingChild) {
        mergeChildren(existingChild.children, newChild.children);
      } else {
        children.push(newChild);
      }
    });
  };

  data.forEach((item) => {
    if (item.root && item.root.children) {
      mergeChildren(mergedResult.children, item.root.children);
    }
  });

  return [mergedResult];
}

export const addSiteId = (
  data: any,
  siteId: string
): SolutionAssetBulkDigitalTwinsRootItem => {
  const recursiveAddSiteId = (
    item: any,
    siteId: string
  ): SolutionAssetBulkDigitalTwinsItem => {
    if (item.level > 0) {
      item.siteId = siteId;
    }

    if (item.children && item.children.length > 0) {
      item.children = item.children.map((child) =>
        recursiveAddSiteId(child, siteId)
      );
    }

    return item;
  };

  const result = recursiveAddSiteId(data.root, siteId);
  return {
    root: { ...result },
  };
};

export const mapAssetBulkDigitalTwingsData = (
  data
): SolutionAssetBulkDigitalTwinsItem[] => {
  const mergedData = mergeObjects(data);

  return mergedData;
};

export const mapSubscriptionsData = (
  response
): DefaultDatasetUnit<SolutionSubscriptionItem[]> => ({
  data: response.map(({ target, ...rest }) => ({
    target: target.url,
    useAuth: !!target.headers.Authorization,
    Authorization: target.headers.Authorization,
    ...rest,
  })),
});

export const mapSolutionNamespaceRscLimitData = (
  response
): SolutionNamespaceRscLimitData => {
  const { id, metadata } = response;
  const parsedValues = JSON.parse(
    metadata.annotations['field.cattle.io/containerDefaultResourceLimit']
  );

  return {
    data: {
      id,
      name: metadata.name,
      requestsCpu: parsedValues.requestsCpu,
      requestsMemory: parsedValues.requestsMemory,
      limitsCpu: parsedValues.limitsCpu,
      limitsMemory: parsedValues.limitsMemory,
      limitsGpu: parsedValues.limitsGpu,
    },
  };
};

export const mapSolutionNamespaceRscQuotasDetailData = (
  response,
  clusterId
): SolutionNamespaceRscQuotasDetailItem => {
  const { data } = response;
  const result = data[0];

  return {
    id: result.id,
    clusterId,
    usedRequestsCpu: result.status.used['requests.cpu'],
    usedRequestsMemory: result.status.used['requests.memory'],
    usedLimitsCpu: result.status.used['limits.cpu'],
    usedLimitsMemory: result.status.used['limits.memory'],
    usedRequestsStorage: result.status.used['requests.storage'],
  };
};
